module.exports = "/_next/static/images/TrucksOnRoad-afbbcd63e3dfe128559a7f392100edb5.png.webp";